import { colors, styled } from 'assets/theme';
import React, { useEffect, useState } from 'react'
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';

const config = [
  { label:'ES 1', instrument: 'VPMES1'},
  { label:'ES 5', instrument: 'VPMES5'},
  { label:'ES 60', instrument: 'VPMES60'},
  { label:'NQ 1', instrument: 'VPMNQ1'},
  { label:'NQ 5', instrument: 'VPMNQ5'},
  { label:'NQ 60', instrument: 'VPMNQ60'},
]

export interface IStmomoData {
  type_id: number
  time: number
  close: number
  hrv: number
  avg_hrv: number
  percentile90: number
  percentile10: number
  range_in_avg_hrv: number
  min_percentile90: number
  max_percentile10: number
  percentile85: number
  percentile15: number
  trade_signal: number
  trend_count: number
  stop_out: number
  stop_out_trend_count: number
  trade_signal_final: number
  initial_entry_point: number
  tftf90: number
  tftf10: number
  min_max_close: number
  projected_stop_out: number
  percentile95: number
  stmomo: string
  second_entry: number
  third_entry: number
  avg_rv_trend: number
}

const getStmomoColor = (stmomo: string): string => {
  switch (stmomo) {
    case 'BUY':
      return colors.accents.good.base
    case 'SELL':
      return colors.accents.bad.base
    case 'STOPOUT':
      return colors.accents.aware.base
  }
  return ''
}

export const TrendModelRow: React.FunctionComponent<{ id: number, sym: string, label: string}> = ({ id, sym, label }) => {
  const [stmomoRowData, setStmomoRowData] = useState<IStmomoData>()
  const [modelRowData, setModelRowData] = useState<any>()

  useEffect(() => {
    subscribeListener(`model:${sym}:1tick`, id, ({ data }) => {
      if (Array.isArray(data) && data.length > 0) {
        setModelRowData(data[data.length -1])
      }
    })
    subscribeListener(`stmomo:${sym}`, id, ({ data }) => {
      setStmomoRowData(data)
    })
    return () => {
      unsubscribeListener(`model:${sym}:1tick`, id)
      unsubscribeListener(`stmomo:${sym}`, id)
    }
  }, [id, sym])
  if (!modelRowData || !stmomoRowData) {
    return <tr />
  }

  let color = ''
  if (modelRowData && modelRowData.nc) {
    color = modelRowData.nc > 0 ? colors.accents.good.base : colors.accents.bad.base;
  }

  return (
    <tr key={sym}>
      <td>{label}</td>
      <td style={{ textAlign: 'center', color }}>{modelRowData.Close !== undefined ? modelRowData.Close.toFixed(2) : ''}</td>
      <td style={{ textAlign: 'center', color: getStmomoColor(stmomoRowData.stmomo) }}>{stmomoRowData.stmomo}</td>
      <td style={{ textAlign: 'right' }}>{stmomoRowData.initial_entry_point === undefined || stmomoRowData.initial_entry_point === -1 ? '': stmomoRowData.initial_entry_point.toFixed(2) }</td>
      <td style={{ textAlign: 'right' }}>{sym.includes('60') && stmomoRowData.second_entry !== undefined ? stmomoRowData.second_entry.toFixed(2) : '' }</td>
      <td style={{ textAlign: 'right' }}>{sym.includes('60') && stmomoRowData.third_entry !== undefined ? stmomoRowData.third_entry.toFixed(2) : '' }</td>
      <td style={{ textAlign: 'right', color: colors.accents.aware.base }}>{stmomoRowData.projected_stop_out !== undefined ? stmomoRowData.projected_stop_out.toFixed(2) : '' }</td>
    </tr>
  )
}

export const TrendModel: React.FunctionComponent<{id: number}> = ({ id }) => {
  return (
    <ModelOutputTable>
      <ModelOutputTableHead>
        <tr>
          <th>Instrument</th>
          <th style={{ textAlign: 'center' }}>Current Price</th>
          <th style={{ textAlign: 'center' }}>Trend Trade</th>
          <th style={{ textAlign: 'center' }}>A.I. Probability</th>
          <th style={{ textAlign: 'right' }}>Initial Entry</th>
          <th style={{ textAlign: 'right' }}>2nd Entry</th>
          <th style={{ textAlign: 'right' }}>3rd Entry</th>
          <th style={{ textAlign: 'right', opacity: 1.0, color: colors.accents.aware.base }}>Stop Out</th>
        </tr>
      </ModelOutputTableHead>
      <ModelOutputTableBody>
        {
          config.map(item => <TrendModelRow key={item.instrument} label={item.label} id={id} sym={item.instrument} />)
        }
      </ModelOutputTableBody>
    </ModelOutputTable>
  );
};

const ModelOutputTable = styled.table`
  width: 100%;
  td {
    padding: 5px;
  }
`

const ModelOutputTableHead = styled.thead`
  border-bottom: 2px solid ${({ theme }) => theme.core.alternateBackground};
  margin-bottom: 1em;
  th {
    text-decoration: underline;
  }
  font-family: Lato;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`

const ModelOutputTableBody = styled.tbody`
  font-family: Lato;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  > :nth-child(2n) {
    background: ${({ theme }) => theme.core.alternateBackground};
  }
`
